import React from 'react';
import { trackWhatsAppClick, trackCallClick, trackCtaClick } from '../../../utils/gtm';
import { IconArrowRight, IconPhone, IconWhatsApp } from './Icons';

const SiteHeader = ({ onOpenModal }) => (
  <header className="bk-header" data-screen-label="Header">
    <div className="bk-container bk-header-row">
      <a href="/" className="bk-logo-link" aria-label="Standard Auditing, home">
        <img
          src="/standard-auditing-logo-1.webp"
          alt="Standard Auditing"
          className="bk-logo-img"
          width="149"
          height="45"
          fetchPriority="high"
          decoding="async"
        />
      </a>

      <div className="bk-header-actions">
        <a
          href="tel:+971542119784"
          className="bk-header-phone gtm-phone-link"
          title="Call Standard Auditing"
          data-gtm-id="header-phone-link"
          id="headerPhoneLink"
          onClick={() => trackCallClick('header_phone')}
        >
          <IconPhone size={16} />
          <span>+971 54 211 9784</span>
        </a>

        <a
          href="https://wa.me/971542119784"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackWhatsAppClick('header_button')}
          className="bk-header-wa gtm-whatsapp-btn"
          data-gtm-id="header-whatsapp-cta"
          id="headerWhatsappBtn"
        >
          <IconWhatsApp size={18} />
          <span>WhatsApp</span>
        </a>

        <button
          type="button"
          onClick={() => { trackCtaClick('header_get_expert_advice'); onOpenModal(); }}
          className="bk-header-cta gtm-cta-btn"
          data-gtm-id="header-modal-cta"
          id="headerModalCtaBtn"
        >
          <span>Get my fixed quote</span>
          <IconArrowRight />
        </button>
      </div>
    </div>
  </header>
);

export default SiteHeader;
